<template>
  <kd-layout-fixed-bottom-button class="add-or-edit-address-page">
    <kd-fragment>
      <kd-cell-group>
        <kd-cell title="收货人">
          <template #append>
            <kd-input v-model.trim="form.name" clearable placeholder="请填写收货人姓名" />
          </template>
        </kd-cell>

        <kd-cell title="手机号">
          <template #append>
            <kd-input v-model.trim="form.phone" clearable placeholder="请填写收货人手机号" />
          </template>
        </kd-cell>

        <kd-cell title="所在地区">
          <template #append>
            <kd-region-select :value="region" @select="selectRegion" />
          </template>
        </kd-cell>

        <kd-cell title="详细地址">
          <template #append>
            <kd-input v-model.trim="form.address" clearable placeholder="具体街道、楼牌号等" />
          </template>
        </kd-cell>
      </kd-cell-group>
    </kd-fragment>

    <kd-fragment>
      <kd-cell-group>
        <kd-cell title="设为默认地址">
          <template #append>
            <mt-switch v-model="form.default"></mt-switch>
          </template>
        </kd-cell>
      </kd-cell-group>
    </kd-fragment>
    <template #footer>
      <kd-button class="del-btn" @click="del" v-if="isEdit">删除</kd-button>

      <kd-button class="save-btn" @click="save">保存</kd-button>
    </template>
  </kd-layout-fixed-bottom-button>
</template>
<script lang="ts">
import { StringUtil } from 'kuaidong-lib'
import { BasePage, Component, Prop } from 'kuaidong-component'
import {
  KdLayoutFixedBottomButton,
  KdButton,
  KdFragment,
  KdCell,
  KdCellGroup,
  KdInput,
  KdRegionSelect,
} from 'kuaidong-ui'
import { Switch } from 'mint-ui'
import { ITeacherAddressInfo, ITeacherAddressInfoForm } from 'kuaidong-model'
import { AGiftOrder } from 'kuaidong-api/src/AGiftOrder'
@Component({
  components: {
    KdLayoutFixedBottomButton,
    KdButton,
    KdFragment,
    KdCell,
    KdCellGroup,
    KdInput,
    KdRegionSelect,
    MtSwitch: Switch,
  },
})
export default class AddOrEditAddressComp extends BasePage {
  @Prop({ type: Object, required: false })
  addressInfo?: ITeacherAddressInfo

  get isEdit() {
    return !!this.addressInfo
  }

  get region() {
    const { province, city, district } = this.form
    return { province, city, district }
  }

  form: ITeacherAddressInfo | ITeacherAddressInfoForm = {
    name: '',
    phone: '',
    province: '',
    city: '',
    district: '',
    address: '',
    default: true,
  }

  async created() {
    if (this.addressInfo) {
      this.form = {
        ...this.addressInfo,
      }
    }
    // 传递参数，设定为默认
    if (this._getQuery('set_default')) {
      this.form.default = true
    }
  }

  selectRegion({ province, city, district }: any) {
    this.form = {
      ...this.form,
      province,
      city,
      district,
    }
  }

  validate() {
    if (this.form.name === '') {
      this.toast('请填写收货人姓名~')
      return false
    }

    if (this.form.phone === '') {
      this.toast('请填写收货人手机号~')
      return false
    }

    if (!StringUtil.validateChinaMobilePhoneNumber(this.form.phone)) {
      this.toast('请填写有效的收货人手机号~')
      return false
    }

    if (this.form.province === '' || this.form.city === '' || this.form.district === '') {
      this.toast('请填写所在地区~')
      return false
    }

    if (this.form.address === '') {
      this.toast('请填写详细地址~')
      return false
    }

    return true
  }

  async save() {
    if (this.validate()) {
      if (this.isEdit) {
        try {
          await AGiftOrder.updateTeacherAddress(this.form as ITeacherAddressInfo)
          this.toast('更新地址成功~')
        } catch (e) {
          this.toast('更新地址失败~')
        }
      } else {
        try {
          await AGiftOrder.addTeacherAddress(this.form as ITeacherAddressInfoForm)
          this.toast('新增地址成功~')
        } catch (e) {
          this.toast(e.data)
        }
      }
    }
  }

  async del() {
    try {
      await AGiftOrder.delTeacherAddress((this.form as ITeacherAddressInfo).address_id)
      this.toast('删除地址成功~')
      this.$router.go(-1)
    } catch (e) {
      this.toast('删除地址失败~')
    }
  }
}
</script>
<style lang="less">
.kd-layout-fixed-bottom-button.add-or-edit-address-page {
  > .kd-layout-fixed-bottom__main {
    > .kd-fragment {
      > .kd-fragment__content {
        > .kd-cell-group {
          border-radius: 8px;

          > .kd-cell {
            > .kd-cell__wrapper {
              > .kd-input {
                > .kd-input__input {
                  font-weight: 400;
                  font-size: 14px;
                  line-height: 20px;
                  color: #4d4d4d;
                }
              }
              > .kd-region-select {
                > div {
                  > .kd-input {
                    border: none;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 20px;
                    color: #4d4d4d;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    > input {
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                      text-align: right;
                    }
                    > .append {
                      margin-left: 0;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  > .kd-layout-fixed-bottom__footer {
    display: flex;
    > .del-btn {
      border: 1px solid #f24b53;
      border-radius: 8px;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #f24b53;
      background: #fff;
      margin-right: 25px;
      width: 90px;
      box-sizing: border-box;
    }

    > .save-btn {
      flex: 1;
    }
  }
}
</style>
